import * as Sentry from "@sentry/react";

type ClientLogContext = Record<string, unknown>;

function isDev() {
  return import.meta.env.DEV;
}

function shouldSendToSentry() {
  return Boolean(import.meta.env.VITE_SENTRY_DSN);
}

export function logDebug(message: string, context?: ClientLogContext) {
  if (isDev()) {
    console.debug(message, context);
  }
}

export function logInfo(message: string, context?: ClientLogContext) {
  console.info(message, context);
}

export function logWarn(message: string, context?: ClientLogContext) {
  console.warn(message, context);

  if (shouldSendToSentry()) {
    Sentry.captureMessage(message, {
      level: "warning",
      extra: context,
    });
  }
}

export function logError(error: unknown, context?: ClientLogContext) {
  console.error(error, context);

  if (!shouldSendToSentry()) {
    return;
  }

  if (error instanceof Error) {
    Sentry.captureException(error, {
      extra: context,
    });
    return;
  }

  Sentry.captureMessage(String(error), {
    level: "error",
    extra: context,
  });
}
export const log = {
  debug: logDebug,
  info: logInfo,
  warn: logWarn,
  error: logError,
};
